import React, { useState, useRef, useEffect } from "react"

const DEFAULT_TILE = 23
const BUTTON_BORDER_TILE = 16

const StyledBorderView = ({
  children,
  borderFolder = "border",
  tileSize,
  className = "",
  style = {},
  contentClassName = "",
  contentStyle = {},
}) => {
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 })
  const containerRef = useRef(null)
  const baseUrl = process.env.PUBLIC_URL || ""
  const imgBase = `${baseUrl}/assets/subterra-fors-assets/images/${borderFolder}`

  const T = tileSize ?? (borderFolder === "button-border" ? BUTTON_BORDER_TILE : DEFAULT_TILE)

  useEffect(() => {
    const el = containerRef.current
    if (!el) return
    const ro = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const { width, height } = entry.contentRect
        setDimensions({ width, height })
      }
    })
    ro.observe(el)
    return () => ro.disconnect()
  }, [])

  const { width, height } = dimensions
  const topWidth = Math.max(0, width - T * 2)
  const sideHeight = Math.max(0, height - T * 2)

  const edgeStyle = (bgFile) => ({
    backgroundImage: `url("${imgBase}/${bgFile}")`,
    backgroundSize: `${T}px ${T}px`,
  })

  return (
    <div
      ref={containerRef}
      className={`sf-border-container ${className}`.trim()}
      style={{ "--sf-border-tile": T, ...style }}
    >
      {width > 0 && height > 0 && (
        <div className="sf-border-overlay" aria-hidden="true">
          {/* Corners */}
          <img
            src={`${imgBase}/top-left.png`}
            alt=""
            className="sf-border-corner sf-border-tl"
            style={{ width: T, height: T }}
          />
          <img
            src={`${imgBase}/top-right.png`}
            alt=""
            className="sf-border-corner sf-border-tr"
            style={{ width: T, height: T }}
          />
          <img
            src={`${imgBase}/bottom-left.png`}
            alt=""
            className="sf-border-corner sf-border-bl"
            style={{ width: T, height: T }}
          />
          <img
            src={`${imgBase}/bottom-right.png`}
            alt=""
            className="sf-border-corner sf-border-br"
            style={{ width: T, height: T }}
          />
          {/* Edges - tiled */}
          <div
            className="sf-border-edge sf-border-top"
            style={{
              left: T,
              width: topWidth,
              height: T,
              ...edgeStyle("top.png"),
            }}
          />
          <div
            className="sf-border-edge sf-border-bottom"
            style={{
              left: T,
              width: topWidth,
              height: T,
              ...edgeStyle("bottom.png"),
            }}
          />
          <div
            className="sf-border-edge sf-border-left"
            style={{
              top: T,
              height: sideHeight,
              width: T,
              ...edgeStyle("left.png"),
            }}
          />
          <div
            className="sf-border-edge sf-border-right"
            style={{
              top: T,
              height: sideHeight,
              width: T,
              ...edgeStyle("right.png"),
            }}
          />
        </div>
      )}
      <div
        className={`sf-border-content ${contentClassName}`.trim()}
        style={{ padding: T, ...contentStyle }}
      >
        {children}
      </div>
    </div>
  )
}

export default StyledBorderView
